module.exports = __webpack_public_path__ + "static/media/badge_header_preview.f87f0efc.svg";